import React from 'react';
import cn from 'classnames';

import { isTranslate } from 'shared/lib/lang';

import {IColumn} from '../Table';

import styles from './SortableTableHead.module.scss';

interface ITableHeadProps {
    columns: IColumn[],
}

const TableHead: React.FC<ITableHeadProps> = ({columns}) => {

    return (
        <thead>
            <tr className={cn(
                styles.wrapper,
                styles[isTranslate() ? 'enThead' : 'ruThead'],
            )}>
                {columns.map((col, i) =>
                    <th key={i} className={styles.th}>
                        {col.label}
                    </th>,
                )}
            </tr>
        </thead>
    );
};

export default React.memo(TableHead);